<!-- <footer class="container-fluid site-footer">
  <div class="text-center">
    <strong>Copyright © 2018 Euroland Shareholders</strong>
  </div>
</footer> -->
<!-- <div class="container-fluid">
  <div class="row pt-4">
    <div class="col-md-12 text-center mb-2">
      <small> © 2021 Copyright Euroland. </small>
    </div>
    <div class="col-md-12 text-center mb-2">
      <small>All Rights Reserved by <span
          class="text-secondary font-weight-bold">EurolandCom
          </span></small>
    </div>
  </div>

</div> -->

<!-- <footer class="site-footer">
  <div class="container">
      <div class="content-wrapper">
          <div class="left-section">
              <div class="policies">
                  <a href="https://tools.eurolandir.com/legal/cookie/?lang=sv-SE" class="footer-link" target="_blank">Policy for cookies</a>
                  <a href="https://tools.eurolandir.com/legal/privacy/?lang=sv-SE" class="footer-link" target="_blank">Privacy Policy</a>
              </div>
              <div class="copy-right">Copyright © 2018 Euroland Shareholders</div>
          </div>

          <div class="right-section">
              <span>
                <i class="fa fa-envelope fa-lg" aria-hidden="true"> </i>

                Euroland Support: </span>
                 <a href="mailto:shareholders@euroland.com" class="footer-link">shareholders@euroland.com</a>
          </div>
      </div>
  </div>
</footer> -->


<!-- <footer>ffooottttere working</footer> -->

<footer>
  <div class="d-flex bd-highlight fill">
    <div class="p-2 flex-fill align-self-center bd-highlight">
      <span *ngIf="privacy">
        <a href="https://tools.eurolandir.com/legal/cookie/?lang=sv-SE" class="footer-link" target="_blank">{{"PrivacyForCookies" | translate}} </a> |
        <a href="https://tools.eurolandir.com/legal/privacy/?lang=sv-SE" class="footer-link" target="_blank">{{"PrivacyPolicy" | translate}}</a>
      </span>
    </div>
    <div class="p-2 flex-fill align-self-center bd-highlight justify-content-center">
      Copyright © 2021 <strong>{{"Sitetitle" | translate}}</strong>
    </div>
  </div>
</footer>

